import { listRequest, listRequestSuccess, setTotalCount } from '../../../../common/components/SSPList/actions';

export const normalize = (value) => (value ?? '').toString().toLowerCase();

export const applyFilters = (rows, filterBy, filterLogic = null) => {
  if (!filterBy || (Array.isArray(filterBy) && filterBy.length === 0)) return rows;

  const filters = Array.isArray(filterBy) ? filterBy : [];

  return rows.filter((row) =>
    filters.every((filterItem) => {
      const filterId = filterItem?.id;
      const filterValue = filterItem?.value;

      if (!filterId || filterValue === undefined || filterValue === null || filterValue === '') return true;

      if (filterLogic) {
        const filterResult = filterLogic(filterId, filterValue, row);

        if (filterResult !== undefined) return filterResult;
      }

      const cellValue = row?.[filterId];

      return normalize(cellValue).includes(normalize(filterValue));
    }),
  );
};

export const applySorting = (rows, sorting) => {
  const sortId = sorting && sorting.id ? sorting.id : null;
  const sortDesc = sorting && sorting.desc;

  if (!sortId) return rows;

  return [...rows].sort((aRow, bRow) => {
    const leftValue = aRow?.[sortId];
    const rightValue = bRow?.[sortId];

    if (typeof leftValue === 'number' && typeof rightValue === 'number') {
      return sortDesc ? rightValue - leftValue : leftValue - rightValue;
    }

    const leftString = (leftValue ?? '').toString();
    const rightString = (rightValue ?? '').toString();
    const comparison = leftString.localeCompare(rightString);

    return sortDesc ? -comparison : comparison;
  });
};

export const applyPagination = (rows, pageToken, pageSize) => {
  const start = pageToken * pageSize;
  return rows.slice(start, start + pageSize);
};

export const createListAction =
  (rows, filterLogic = null) =>
  (id, { page_token: pageToken = 0, page_size: pageSize = 20, sorting, filter_by: filterBy } = {}) =>
  (dispatch) => {
    dispatch(listRequest(id));

    const safeRows = Array.isArray(rows) ? rows : [];
    const filtered = applyFilters(safeRows, filterBy, filterLogic);
    const sorted = applySorting(filtered, sorting);
    const page = applyPagination(sorted, pageToken, pageSize);

    dispatch(listRequestSuccess(id, page));
    dispatch(setTotalCount(id, sorted.length));
  };
